import { useTranslation } from 'react-i18next';
import { memo, useState } from 'react';

import { Button } from '@unified-checkout/design-system';
import { Copy } from '@unified-checkout/design-system/icons/index';

import type { IButton } from 'libs/design-system/src/types/Button/button';

import styles from './CopyText.module.scss';

const CopyText = ({
  textToCopy,
  buttonProps,
  showTextToCopy = false,
  onCopyChange,
  onCopyTextHandler
}: {
  textToCopy: string;
  buttonProps?: IButton;
  showTextToCopy?: boolean;
  onCopyChange?: (copied: boolean) => void;
  onCopyTextHandler?: (text: string) => void
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t } = useTranslation();

  const hasTextToCopy = !!textToCopy && textToCopy !== '-';

  const handleCopyText = async () => {
    if (textToCopy) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        onCopyTextHandler?.(textToCopy);
        setIsCopied(true);
        onCopyChange?.(true);

        setTimeout(() => {
          setIsCopied(false);
          onCopyChange?.(false);
        }, 2000);
        
      } catch (err) {
        console.error('Failed to copy link:', err);
      }
    }
  };

  return (
    <div className={styles['copy-text']}>
      {showTextToCopy && (
        <span className={styles['copy-text__main-text']}>{textToCopy}</span>
      )}

      {isCopied ? (
        <span
          className={styles['copy-text__copied']}
          data-btn-size={buttonProps?.size || 'sm'}
        >
          {t('copied')}
        </span>
      ) : (
        hasTextToCopy && (
          <Button
            leadingIcon={Copy}
            onClickHandler={handleCopyText}
            size="sm"
            variant="link"
            color="secondary"
            {...buttonProps}
          />
        )
      )}
    </div>
  );
};

export default memo(CopyText);
